import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { IzvodStavka } from './izvod-stavka';

@Component({
  selector: 'yt-izvod-stavka-inline-update',
  templateUrl: './izvod-stavka-inline-update.component.html'
})
export class IzvodStavkaInlineUpdateComponent extends BaseInlineUpdateComponent<IzvodStavka> {

  constructor(protected inlineContainerService: InlineContainerService<IzvodStavka>){
    super(inlineContainerService);
  }
}
